import { get, del, post, put } from "helpers/api_helper/ApiHelpers/apiHelpers"
import * as url from "helpers/url_helper/url_helper";

export const getDistrictDefinition = () => get(url.DISTRICT_DEFINITIONS);
export const addDistrictDefinition = record => post(url.DISTRICT_INSERT, record);
export const updateDistrictDefinition = record => put(url.DISTRICT_UPDATE, record);
export const deleteDistrictDefinition = guid => del(url.DISTRICT_DELETE, { params: { guid } });